import type { Exercise, Workout } from '@jungles/shared';

// Canonical order from the seeded exercise catalog, not workout insertion order.
const MUSCLE_GROUPS = ['Грудь', 'Спина', 'Плечи', 'Ноги', 'Ягодицы', 'Руки', 'Кор'];

/** Catalog groups, not exercise-name heuristics; explicit custom names stay intact. */
export function muscleGroupTitle(title: string, items: { exerciseId: string }[], catalog: Exercise[] | null): string {
  if (!['Своя тренировка', 'Своя'].includes(title)) return title;
  if (!catalog) return 'Тренировка';
  const byId = new Map(catalog.map(exercise => [exercise.id, exercise.muscleGroup]));
  const groups = new Set(items.map(item => byId.get(item.exerciseId)));
  return MUSCLE_GROUPS.filter(group => groups.has(group))
    .map((group, index) => index ? group.toLocaleLowerCase('ru') : group).join(', ') || 'Тренировка';
}

/** Display only: derive generic completed strength/ready names, including template copies. */
export function workoutHistoryTitle(workout: Workout, catalog: Exercise[] | null): string {
  if ((workout.type !== 'strength' && workout.type !== 'ready') || workout.status !== 'done' ||
      !['Своя тренировка', 'Своя'].includes(workout.title) || !catalog) return workout.title;
  return muscleGroupTitle(workout.title, workout.exercises
    // Same performed-set semantics as API volumeOf/setsCountOf; zero is valid.
    .filter((exercise) => exercise.sets.some((set) => set.done || (set.weightKg !== null && set.reps !== null))), catalog);
}
